import { render, staticRenderFns } from "./FormProductType.vue?vue&type=template&id=f19fe11c&scoped=true&"
import script from "./FormProductType.vue?vue&type=script&lang=js&"
export * from "./FormProductType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19fe11c",
  null
  
)

export default component.exports